import { FeatureToggleClientService } from 'feature-toggle-client';
const messageTemplatePaymentFeatureToggle = 'message-template-payment-card-feature-toggle';
const messageTemplateCarouselFeatureToggle = 'growth-message-template-carousel-feature-toggle';
const messageTemplateVideo = 'message-template-video';
const messageTemplateButtons = 'message-template-buttons';
const messageTemplateMarketingCategories = 'message-template-marketing-categories';
const mediaMessageTemplateEnabled = 'remove-media-message-template';
const newMessageAttachmentRouteEnabled = 'use-new-message-attachment-route';
const newestMessageTemplateCategoriesEnabled = 'use-newest-message-template-categories';
const messageTemplateAuthenticationCategoryEnabled = 'use-message-template-authentication-category';
const messageTemplateAiAnalysis = 'message-template-ai-analysis';
const messageTemplateQualityScoreEnabled = 'message-template-quality-score';
const metaBiddingAlpha = 'message-template-meta-bidding-alpha';
export class MessageTemplateFeatures {
    static isMessageTemplateVideoEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(messageTemplateVideo, false);
    }
    static isMessageTemplateButtonsEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(messageTemplateButtons, false);
    }
    static isMessageTemplateMarketingCategoriesEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(messageTemplateMarketingCategories, false);
    }
    static isMediaMessageTemplateEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(mediaMessageTemplateEnabled, false);
    }
    static isNewMessageAttachmentRouteEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(newMessageAttachmentRouteEnabled, this.newMessageAttachmentRouteEnabledDefaultValue);
    }
    static async isNewestMesssageTemplateCategoriesEnabled() {
        const isFeatureEnabled = await FeatureToggleClientService.getInstance().isFeatureEnabled(newestMessageTemplateCategoriesEnabled, false);
        return !isFeatureEnabled;
    }
    static async isMessageTemplateAuthenticationCategoryEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(messageTemplateAuthenticationCategoryEnabled, false);
    }
    static async isMessageTemplateAiAnalysisEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(messageTemplateAiAnalysis, false);
    }
    static async isMessageTemplateQualityScoreEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(messageTemplateQualityScoreEnabled, false);
    }
    static async isMetaBiddingAlphaEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(metaBiddingAlpha, false);
    }
    static async isMessageTemplatePaymentEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(messageTemplatePaymentFeatureToggle, false);
    }
    static async isMessageTemplateCarouselEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(messageTemplateCarouselFeatureToggle, false);
    }
}
MessageTemplateFeatures.newMessageAttachmentRouteEnabledDefaultValue = false;
